import { render, staticRenderFns } from "./sub-items.vue?vue&type=template&id=e646c162&scoped=true"
import script from "./sub-items.vue?vue&type=script&lang=js"
export * from "./sub-items.vue?vue&type=script&lang=js"
import style0 from "./sub-items.vue?vue&type=style&index=0&id=e646c162&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e646c162",
  null
  
)

export default component.exports